import { get } from "@/services/axiosUitils";
import { PranRegistrationResponse } from "@/utils/types/NpsUser";
import { UserStatementofHoldingResponse } from "@/utils/types/UserStatementofHolding";

const base = "/nps/cra/soh/";

class UserStatementofHoldingService {
  listUserStatementofHolding = async (
    page = 1,
    pageSize = 20
  ): Promise<UserStatementofHoldingResponse> => {
    return await get<UserStatementofHoldingResponse>(base, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getUserStatementofHoldingById = async (
    ackId: string
  ): Promise<PranRegistrationResponse> => {
    return await get<PranRegistrationResponse>(`${base}${ackId}/`);
  };
}

const instance = new UserStatementofHoldingService();
export default instance;
